<template lang="pug">
  .b2b-page-consult-invoice-by-link
    ods-module
      div.onesait(slot='header')
        ods-row.link
          ods-col.padding(:span='21')
            p {{ 'onesait' }}
          ods-col(:span='1')
            div.separator
          ods-col(:span='2')
            ods-tooltip(content='Renfe', placement='bottom')
              div.ods-main-header__client-logo
                a(href='http://www.renfe.com' target='_blank')
                  img(
                    :src="urlLogo"
                    alt="logo")
      div.bar(slot='header')
        ods-row
          ods-col(:span='24')
            p {{ 'Ecosystems B2B' }}
      div(slot='header')
        ods-row.info(type='flex', align='middle')
          ods-col(:span='8')
            div {{ $t('msg_generics.invoiceDetails') }} {{ this.invoiceNumber }}
          ods-col(:span='16')
             ods-row(type='flex', justify='end')
                ods-tooltip(:content='$t("invoice_detail.buttons.download_invoice_tooltip")', placement='bottom')
                  ods-button(
                    type='primary',
                    icon='ods-icon-download',
                    size='small',
                    circle,
                    @click.native='handleDownloadInvoicePdf')
                    | {{ $t('invoice_detail.buttons.download_invoice') }}
                ods-tooltip(:content='$t("invoice_detail.buttons.download_original_signed_tooltip")', placement='bottom')
                  ods-button(
                    type='primary',
                    icon='ods-icon-download',
                    size='small',
                    circle,
                    @click.native='handleDownloadSignedOriginal')
                    | {{ $t('invoice_detail.buttons.download_original_signed') }}
      ods-form(
        ref='invoiceDetailEditForm',
        :model='invoiceDetailEditForm',
        label-width='14rem',
        label-position='top',
        size='small',
        status-icon)
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("invoice_detail.invoice_detail_edit_form.invoice_number")',
              prop='invoiceNumber')
              ods-input(
                v-model='invoiceDetailEditForm.invoiceNumber'
                :disabled='true')
            ods-form-item(
              :label='$t("invoice_detail.invoice_detail_edit_form.seller")',
              prop='sellerName')
              ods-input(
                v-model='invoiceDetailEditForm.sellerName',
                :disabled='true')
            ods-form-item(
              :label='$t("invoice_detail.invoice_detail_edit_form.issue_date")',
              prop='issueDate')
              ods-input(
                v-model='issueDateFormatted',
                :disabled='true')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item.vacio()
            ods-form-item(
              :label='$t("invoice_detail.invoice_detail_edit_form.buyer")',
              prop='buyerName')
              ods-input(
                v-model='invoiceDetailEditForm.buyerName',
                :disabled='true')
            ods-form-item(
              :label='$t("invoice_detail.invoice_detail_edit_form.total_executable_amount")',
              prop='totalExecutableAmount')
              ods-input(
                v-model='invoiceDetailEditForm.totalExecutableAmount'
                :disabled='true')
        ods-row
          ods-col(:span='24')
            ods-form-item(
              v-if='invoiceDetailEditForm.internalNotes && invoiceDetailEditForm.internalNotes.length > 0',
              :label='$t("invoice_detail.invoice_detail_edit_form.internal_notes")',
              prop='internalNotes')
              ods-input(
                v-model='invoiceDetailEditForm.internalNotes',
                :disabled='true',
                type='textarea',
                rows='5')
    ods-module.collapse
      ods-accordion(@change="loadAttachments")
        ods-accordion-item(name='1')
          template(slot='title')
            span {{ $t('invoice_detail.attachment') }}
            span.info(v-show='!attachments.length && attachmentMessage') {{ $t('invoice_detail.no_attachment') }}
          //- Tabla de Adjuntos
          ods-table(
            v-if='attachments.length > 0 ',
            :data='attachments',
            :default-sort='{ prop: "creationDate", order: "descending" }',
            style='width: 100%',
            @cell-mouse-enter='handleCellMouseEnter',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='filename',
              :label='$t("invoice_detail.attachments_table.filename")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='category',
              :label='$t("invoice_detail.attachments_table.category")',
              :show-overflow-tooltip='true',
              :formatter= 'formatterCategory'
              sortable='')
            ods-table-column(
              prop='size',
              :label='$t("invoice_detail.attachments_table.size")',
              :show-overflow-tooltip='true',
              :formatter='formatterKBSize',
              align='right',
              sortable='')
            ods-table-column(
              prop='compressedSize',
              :label='$t("invoice_detail.attachments_table.compressed_size")',
              :show-overflow-tooltip='true',
              :formatter='formatterKBSize',
              align='right',
              sortable='')
            ods-table-column(
              prop='creationDate',
              width='110',
              :label='$t("invoice_detail.attachments_table.creation_date")',
              align='center',
              :show-overflow-tooltip='true',
              :formatter='formatterDate',
              sortable='')
            ods-table-column(
              prop='author',
              :label='$t("invoice_detail.attachments_table.author")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              width='80')
              template(slot-scope='scope')
                ods-tooltip(:content='$t("buttons.btnDownload")', placement='bottom')
                  ods-button.first-button(
                    type='neutral',
                    @click='downloadAttachment')
                    ods-icon(name='download', size='16')
      ods-accordion(@change="loadEvents")
        ods-accordion-item(name='2')
          template(slot='title')
            span {{ $t('invoice_detail.events.title') }}
            span.info(v-show='!events.length && eventMessage') {{ $t('invoice_detail.events.no_events') }}
            i(class='header-icon ods-icon-information')
          ods-row()
            b2b-timeline(:events='events')
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import B2bTimeline from '@/components/B2bTimeline'
import Utils from '@/components/shared/Utils'
import moment from 'moment'

export default {
  name: 'b2b-page-consult-invoice-by-link',

  mixins: [Utils],

  data () {
    return {
      // INFO
      invoiceOriginal: {}, // Factura original sin modificaciones de ningun tipo
      projectId: null, // id del proyecto de la factura
      invoiceId: null,
      invoiceNumber: null,
      invoiceDetailEditForm: {
        // EDITABLES
        invoiceNumber: null,
        totalExecutableAmount: null,
        // NO EDITABLES
        buyerName: '',
        issueDate: '',
        sellerName: '',
        // Otros
        sent: null,
        emission: null
      },
      // ADJUNTOS
      attachments: [],
      currentRowAttachments: {},

      // EVENTOS
      events: [],
      // ACCORDION FLAGS
      eventFlag: true,
      eventMessage: false,
      attachmentFlag: true,
      attachmentMessage: false,

      // Tipo de búsqueda: emitidas
      searchType: 'EMITTED'
    }
  },

  components: {
    B2bTimeline
  },

  computed: {
    ...mapGetters([
      'canSeeAttachments',
      'canSeeEvents',
      'canAdminIndra',
      'canViewAttach'
    ]),

    issueDateFormatted () { // eslint-disable-line
      if (this.invoiceDetailEditForm.issueDate) {
        return moment(this.invoiceDetailEditForm.issueDate).format(this.$t('date_format'))
      }
    },
    urlLogo () {
      return require('@/assets/images/projects/renfe.svg')
    }
  },

  methods: {
    ...mapActions([
      'getInvoiceNoteByLink',
      'handleDownloadMultiInvoiceNotesPdf',
      'handleDownloadMultiInvoiceSignedOriginal',
      'getInvoiceNoteAttachments',
      'downloadInvoiceNoteAttachment',
      'getInvoiceNoteEvents'
    ]),

    // Formateo a KB
    formatterKBSize (row, column) {
      const number = row[column.property] / 1024
      return this.$n(Math.round(number * 100) / 100, 'decimal') + '  KB'
    },

    formatterDate (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format_long'))
      }
      return this.$t('msg_generics.no_date')
    },

    formatterCategory (row, column) {
      return row[column.property] ? this.$t('auditory_detail.events.code.' + row[column.property]) : ' '
    },

    // INFO
    async handleDownloadInvoicePdf () {
      console.log('handleDownloadInvoicePdf: ', this.invoiceId)
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_pdf')
      })
      // const idList = [this.invoiceId]
      try {
        const idList = [this.invoiceId]
        const filename = await this.handleDownloadMultiInvoiceNotesPdf({
          invoiceNoteId: idList,
          searchType: this.searchType
        })
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleDownloadInvoicePdf CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async handleDownloadSignedOriginal () {
      console.log('handleDownloadSignedOriginal: ', this.invoiceId)
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_invoice_original')
      })
      const idList = [this.invoiceId]
      try {
        const params = {
          invoiceNoteId: idList,
          searchType: this.searchType
        }
        const filename = await this.handleDownloadMultiInvoiceSignedOriginal(params)
        load.close()
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleDownloadSignedOriginal CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    handleCellMouseEnter (row, column, cell, event) {
      this.currentRowAttachments = row
    },
    async downloadAttachment () {
      console.log('downloadAttachment: ', this.invoiceId)
      const load = this.$loading({
        lock: true,
        text: this.$t('invoice_detail.load.download_attachment')
      })
      try {
        const filename = await this.downloadInvoiceNoteAttachment({
          invoiceNoteId: this.invoiceId,
          attachmentId: this.currentRowAttachments.id,
          searchType: this.searchType
        })
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('downloadAttachment CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Get Adjuntos
    async getInvoiceNoteAttachmentsOnDatabase () {
      try {
        const params = {
          invoiceNoteId: this.invoiceId,
          searchType: this.searchType
        }
        this.attachments = await this.getInvoiceNoteAttachments(params)
      } catch (error) {
        console.log('getInvoiceNoteAttachmentsOnDatabase CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },

    // EVENTOS
    async getInvoiceNoteEventsOnDatabase () {
      try {
        this.events = await this.getInvoiceNoteEvents({
          invoiceNoteId: this.invoiceId,
          searchType: this.searchType
        })
      } catch (error) {
        console.log('getInvoiceNoteEventsOnDatabase CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },
    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 401:
          errorSms = this.$i18n.messages.es.error.e401
          break
        case 403:
          errorSms = this.$i18n.messages.es.error.e403
          break
        case 400:
        case 404:
        case 500:
          errorSms = error.data.message
          if (errorSms === undefined) {
            if (error.config.responseType === 'blob') {
              errorSms = this.$t('msg_generics.error_download_not_found')
            } else {
              errorSms = this.$t('error.e500')
            }
          } else if (errorSms && errorSms.indexOf('does not exist') > -1) {
            errorSms = 'No se puede consultar la información para este servicio'
          }
          break
        case 409:
          errorSms = error.data.message
          break
        default:
          errorSms = this.$i18n.messages.es.error.default
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    },
    async loadAttachments () {
      // Get Adjuntos
      if (this.attachmentFlag) {
        this.attachmentFlag = false
        await this.getInvoiceNoteAttachmentsOnDatabase()
        this.attachmentMessage = true
      }
    },
    async loadEvents () {
      // Get Events
      if (this.eventFlag) {
        this.eventFlag = false
        await this.getInvoiceNoteEventsOnDatabase()
        this.eventMessage = true
      }
    }
  },

  async created () {
    console.log('this.$route.query', this.$route.query)
    if (this.$route.query && this.$route.query.invoiceNote) {
      const params = {
        link: this.$route.query.invoiceNote
      }
      const factura = await this.getInvoiceNoteByLink(params)
      this.invoiceId = factura.id
      this.searchType = 'EMITTED'
      if (!factura.emission) {
        this.searchType = 'RECEIVED'
      }
      this.invoiceNumber = factura.invoiceNumber
      this.invoiceOriginal = JSON.parse(JSON.stringify(factura))
      this.invoiceDetailEditForm = factura
      if (this.invoiceDetailEditForm.totalExecutableAmount) {
        this.invoiceDetailEditForm.totalExecutableAmount = this.$n(this.invoiceDetailEditForm.totalExecutableAmount, 'table') + ' ' + this.invoiceDetailEditForm.currencyCode
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-page-consult-invoice-by-link{
  padding: 40px 40px 40px 40px;
  background-color: #f0f1f2 !important;

  .ods-table {
    &__row {
      .ods-button {
        padding: 0px;
        margin-left: 0px;
        margin-right: 0px;
        i {
          margin-left: 0px;
        }
      }
      .first-button {
        padding: 0px;
        margin-left: 0px;
        margin-right: rem(12);
        i {
          margin-left: 0px;
        }
      }
    }
  }

  ::v-deep .ods-module {
    &__header {
      background-color: var(--color-bg-hover-2);
      padding: 0px;

      .info {
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
      .ods-button {
        float: right;
      }
    }

    &__body{
      padding: 32px;
      .info{
        padding-bottom: 32px;
      }
    }
  }

  .form-actions {
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button {
      float: right;
    }
  }

  .collapse {
    margin-top: 64px;
    .info {
      margin-left: 1rem;
      color: var(--color-txt-secondary);
    }

    ::v-deep .ods-table {
      th {
        padding: rem(0);
        padding-top: rem(4);

        .cell {
          font-weight: 500;
        }
      }
      &__row{
        .ods-button {
          padding: 0px;
          margin-left: 0px;
          margin-right: 0px;
          i {
            margin-left: 0px;
          }
        }
        .first-button {
          padding: 0px;
          margin-left: 0px;
          margin-right: rem(12);
          i {
            margin-left: 0px;
          }
        }
      }
    }

    .button-collapse {
      float: right;
    }

    ::v-deep .ods-module{
      &__body{
        padding: 0px;
      }
    }
  }
  ::v-deep .ods-checkbox {
    padding-top: 20px;
  }
  ::v-deep .ods-form-item.hidden label.ods-form-item__label {
    color: transparent !important;
  }
  ::v-deep .ods-form-item.hidden .ods-input.is-disabled .ods-input__inner {
    background-color: transparent !important;
  }
  ::v-deep .ods-module__header, ::v-deep input.ods-input__inner, ::v-deep div.ods-accordion-item__header:hover{
    background-color: #fff0fc !important;
  }
  ::v-deep .ods-table--enable-row-hover .ods-table__body tr:hover>td, ::v-deep .current-row td {
    background-color: #fff0fc !important;
  }
  ::v-deep .ods-textarea.is-disabled .ods-textarea__inner {
    background-color: #fff0fc !important;
  }
  ::v-deep .ods-module__header .info, ::v-deep .ods-button.is-circle > span{
    color: #8a0072 !important;
  }
  ::v-deep .ods-button.is-circle [class*=ods-icon-], ::v-deep .ods-button.is-circle i {
    background-color: #8a0072 !important;
  }
  ::v-deep .ods-module.collapse.is-always-shadow {
    margin-top: 0px;
  }
  ::v-deep .onesait {
    background-color: white !important;
    padding: 9px;
  }
  ::v-deep .bar {
    background-color: #8a0072 !important;
    color: white;
    padding: 9px;
  }
  ::v-deep .link.ods-row {
    font-size: 28px;
    margin: 6px 0 0 0;
    font-family: Soho Gothic Pro, Helvetica, Arial, sans-serif;
    padding-left: 15px;
    padding-bottom: 8px;
    font-weight: 425;
  }
  ::v-deep img {
    width: 60%;
    margin: 0px 0px -10px 30px;
  }
  ::v-deep .separator {
    content: "";
    width: .0625rem;
    height: 2rem;
    background-color: var(--color-border-hard-divisor);
    margin-left: 5.5rem;
    margin-right: 1rem;
  }
  ::v-deep .ods-col.padding {
    padding-top: 7px;
  }
  .ods-form-item.vacio.ods-form-item--feedback.ods-form-item--small {
    height: 52px;
  }
}
</style>
